import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import caseVideoMp4 from "../../images/home-update/case-studies/banner-vid-pure-plank.mp4";
import caseVideoWebm from "../../images/home-update/case-studies/banner-vid-pure-plank.webm";

import { HomeUpdatedArrowSmall } from "../../../app-constants";

function Casestudies(props) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      className="tekrevol__case p-100 overflow-x-hidden"
      ref={sectionRef}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="Our Portfolio">
              <h2>Case Studies</h2>
            </div>
          </Col>
        </Row>
        <Row className="case-outer justify-content-center align-items-center flex-column-reverse flex-md-row row pt-0">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="mt-auto mb-auto">
            <div className="case-img">
              {videoLoaded ? (
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-auto mw-100 case-video"
                >
                  <source src={caseVideoWebm} type="video/webm" />
                  <source src={caseVideoMp4} type="video/mp4" />
                </video>
              ) : (
                <StaticImage
                  src="../../images/home-update/case-studies/case-1.webp"
                  alt="Pure Plank"
                  className="img-fluid mw-100"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["auto"]}
                  width={700}
                  height={394}
                />
              )}
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="mb-md-0 mb-5">
            <div className="case-cont ps-xxl-5 ps-0">
              <div className="case-inner">
                <h3 className="title">Pure Plank</h3>
                <ul className="list list-one">
                  <li>UI/UX Design</li>
                  <li className="bg-one">Mobile App Development</li>
                </ul>
                <p>
                  Pure Plank is a fitness app designed to guide users through
                  effective plank exercises for optimal health and fitness
                  results.
                </p>
                <ul className="list list-two">
                  <li>
                    <span>
                      <strong>98%</strong> User Satisfaction Rate
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>50%</strong> Increase in User Engagement
                    </span>
                  </li>
                  <li>
                    <span>Top-Rated Fitness App in App Store</span>
                  </li>
                </ul>
                <div className="btn-wrap btn_load_all">
                  <Link
                    to="/case-studies/pure-plank"
                    aria-label="View Case Study Pure Plank"
                  >
                    View Case Study
                    {HomeUpdatedArrowSmall}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="case-outer justify-content-center align-items-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-5">
            <div className="case-cont">
              <div className="case-inner">
                <h3 className="title">AMJ Workplace Wellness</h3>
                <ul className="list list-one">
                  <li>Game Design</li>
                  <li className="bg-three">Mobile App Development</li>
                </ul>
                <p>
                  AMJ Workplace Wellness is a holistic wellness app designed to{" "}
                  <br className="d-xxl-block d-none" />
                  promote employee health and fitness in the corporate
                  <br className="d-xxl-block d-none" /> environment.
                </p>
                <ul className="list list-two">
                  <li>
                    <span>Seamless UI/UX Design for Corporate Use</span>
                  </li>
                  <li>
                    <span>Integration with Wearable Devices</span>
                  </li>
                  <li>
                    <span>Real-time Health Tracking and Analysis</span>
                  </li>
                  <li>
                    <span>
                      <strong>80%</strong> Increase in Employee Satisfaction
                    </span>
                  </li>
                  <li>
                    <span>AI-driven Personalized Recommendations</span>
                  </li>
                </ul>
                <div className="btn-wrap btn_load_all">
                  <Link
                    to="/case-studies/amj-wellness"
                    aria-label="View Case Study AMJ Workplace Wellnesss"
                  >
                    View Case Study
                    {HomeUpdatedArrowSmall}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto mb-auto">
            <div className="case-img text-lg-right text-center">
              {videoLoaded ? (
                <StaticImage
                  src="../../images/home-update/case-studies/case-2_big.webp"
                  alt="AMJ Workplace Wellness"
                  className="img-fluid amj_big"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={2127}
                  height={2036}
                />
              ) : (
                <StaticImage
                  src="../../images/home-update/case-studies/case-2.webp"
                  alt="AMJ Workplace Wellness"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["auto"]}
                  width={748}
                  height={687}
                />
              )}
            </div>
          </Col>
        </Row>
        <Row className="case-outer justify-content-center align-items-center flex-column-reverse flex-md-row row">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-lg-0 mb-5">
            <div className="case-img text-lg-right text-center">
              {videoLoaded ? (
                <StaticImage
                  src="../../images/home-update/case-studies/case-3_big.webp"
                  alt="Super App Yeppy"
                  className="img-fluid truth_big"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={2241}
                  height={2067}
                />
              ) : (
                <StaticImage
                  src="../../images/home-update/case-studies/case-3.webp"
                  alt="Truth GPT"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["auto"]}
                  width={739}
                  height={682}
                />
              )}
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-5">
            <div className="case-cont ps-xxl-5 ps-0">
              <div className="case-inner">
                <h3 className="title">Truth GPT</h3>
                <ul className="list list-one">
                  <li>UI/UX Design</li>
                  <li className="bg-four">Mobile App Development</li>
                </ul>
                <p>
                  AI-powered mobile application designed for transparent,
                  accessible information through a chatbot interface. Developed
                  to enhance interaction realism with advanced Flutter
                  animations, engaging 3D models, and prompt contextual
                  engineering for quick, helpful responses.
                </p>

                <ul className="list list-two">
                  <li>
                    <span>
                      <strong>40%</strong> More Interactions with Flutter
                      Animations
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>3X</strong> Engagement via 3D Features
                    </span>
                  </li>
                  <li>
                    <span>Quality Responses with Semantic Search</span>
                  </li>
                </ul>
                <div className="btn-wrap btn_load_all">
                  <Link
                    to="/case-studies/truth-gpt"
                    aria-label="View Case Study Truth GPT"
                  >
                    View Case Study
                    {HomeUpdatedArrowSmall}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="case-outer justify-content-center align-items-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-5">
            <div className="case-cont pe-xxl-5 pe-0">
              <div className="case-inner">
                <h3 className="title">Find Serve & Keep</h3>
                <ul className="list list-one">
                  <li>Game Design</li>
                  <li className="bg-four">Mobile App Development</li>
                </ul>
                <p>
                  FSK revolutionizes mobile gaming with its innovative fusion of
                  match-3 puzzles, time management challenges, and captivating
                  role-playing elements.
                </p>

                <ul className="list list-two">
                  <li>
                    <span>Immersive Role-Playing Narrative</span>
                  </li>
                  <li>
                    <span>Real-Time Market Strategies</span>
                  </li>
                  <li>
                    <span>Monetization Without Disruption</span>
                  </li>
                  <li>
                    <span>Engaging User Experience</span>
                  </li>
                </ul>
                <div className="btn-wrap btn_load_all">
                  <Link
                    to="/case-studies/fsk"
                    aria-label="View Case Study Find Serve & Keep"
                  >
                    View Case Study
                    {HomeUpdatedArrowSmall}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto mb-auto">
            <div className="case-img text-lg-right text-center">
              <StaticImage
                src="../../images/home-update/case-studies/case-4_sample.webp"
                alt="Find Serve & Keep"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["auto"]}
                width={910}
                height={575}
              />
              {/* {videoLoaded ? (
                <StaticImage
                  src="../../images/home-update/case-studies/case-4_big.webp"
                  alt="Super App Yeppy"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={2747}
                  height={1479}
                />
              ) : (
                <StaticImage
                  src="../../images/home-update/case-studies/case-4.webp"
                  alt="Find Serve & Keep"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["auto"]}
                  width={776}
                  height={418}
                />
              )} */}
            </div>
          </Col>
        </Row>
        <Row className="case-outer justify-content-center align-items-center flex-column-reverse flex-md-row row">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <div className="case-img text-lg-right text-center">
              {videoLoaded ? (
                <StaticImage
                  src="../../images/home-update/case-studies/case-5_big.webp"
                  alt="Super App Yeppy"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={2632}
                  height={2019}
                />
              ) : (
                <StaticImage
                  src="../../images/home-update/case-studies/case-5.webp"
                  alt="Super App Yeppy"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["auto"]}
                  width={776}
                  height={595}
                />
              )}
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-5">
            <div className="case-cont ps-xxl-5 ps-0">
              <div className="case-inner">
                <h3 className="title">Super App Yeppy</h3>
                <ul className="list list-one">
                  <li>UI/UX Design</li>
                  <li className="bg-five">Mobile App Development</li>
                  <li className="bg-six">Multi-Service Integration</li>
                </ul>
                <p>
                  Super App Yeppy revolutionizes mobile experiences by
                  consolidating diverse services into one intuitive platform,
                  catering to users' daily needs seamlessly.
                </p>

                <ul className="list list-two">
                  <li>
                    <span>
                      <strong>30%</strong> increase in user engagement within
                      the first month
                    </span>
                  </li>
                  <li>
                    <span>Enhanced Convenience and Accessibility</span>
                  </li>
                  <li>
                    <span>Seamless Navigation and Functionality</span>
                  </li>
                  <li>
                    <span>
                      <strong>95%</strong> positive user feedback on app
                      usability
                    </span>
                  </li>
                </ul>
                <div className="btn-wrap btn_load_all">
                  <Link
                    to="/case-studies/yeppy"
                    aria-label="View Case Study Super App Yeppy"
                  >
                    View Case Study
                    {HomeUpdatedArrowSmall}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Casestudies;
